enum SyntheticMediaEventType {
    TIME_UPDATE = 'TIME_UPDATE',
    CUE_CHANGE = 'CUE_CHANGE',
    AUTOPLAY_REJECTION = 'AUTOPLAY_REJECTION',
    READY = 'READY'
}

export default SyntheticMediaEventType;